export default __webpack_public_path__ + "static/bravo-sea-trials-poster-755fc91c585c1213f535de9d33ea72df.jpg";